"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LowChicagoOptions = void 0;
/** LowChicagoOptions.tsx
 *
 * Game Options for LowChicago.
 */
const BetLimit_1 = require("../bets/BetLimit");
const CardVersionSetting_1 = require("../enums/CardVersionSetting");
const defaultOptions_1 = require("./defaultOptions");
exports.LowChicagoOptions = {
    versions: [
        {
            title: "7 Cards",
            description: "",
            value: CardVersionSetting_1.CardVersionSetting.SEVEN_CARD,
            default: true,
            flavor: 7,
            betLimit: BetLimit_1.BetLimit.SPREAD_LIMIT,
        },
    ],
    winners: [
        Object.assign(Object.assign({}, defaultOptions_1.winnerHighOnlyDefault), { description: "High hand splits with low spade in the hole" }),
    ],
    options: [
        defaultOptions_1.optionNoneDefault,
        Object.assign(Object.assign({}, defaultOptions_1.optionRollYourOwn), { description: "Roll Your Own (First card)" }),
    ],
    wildcards: [
        defaultOptions_1.wildcardNoneDefault,
        defaultOptions_1.wildcardLowHoleWithBuy,
        defaultOptions_1.wildcardDeuces,
        defaultOptions_1.wildcardOneEyedJacks,
    ],
};
//# sourceMappingURL=LowChicagoOptions.js.map